export const enrollAutomaticPaymentData = [
  {
    Question: `How can I enroll in automatic payments with WM?`,
    Answer: `1. Login to MyWM   

         2. Click "Autopay" under the "Manage Accounts"   
  
         3. Here you will find options to manage your recurring subscription(s), including enrollment.     
  
         Note: Make sure you are signed in to the correct account before attempting to link another account. Visit our webpage for a video tutorial.`,
  },
]
